var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTandem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 68,
    viewBox: "0 0 92 68",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h92v68h-92z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeWidth: 2,
    transform: "translate(-765.766 -967.944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m790.089 1016.427a11.162 11.162 0 1 1 -11.162-11.161 11.163 11.163 0 0 1 11.162 11.161z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m794.151 1016.428h-15.224l7.651-11.408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m814.06 1005.511-16.492 10.918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m792.458 1001.341h19.608"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m781.175 1016.427a2.247 2.247 0 1 1 -2.248-2.247 2.248 2.248 0 0 1 2.248 2.247z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856.535 1016.427a11.162 11.162 0 1 1 -11.162-11.161 11.163 11.163 0 0 1 11.162 11.161z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m825.465 1016.428h-27.897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m823.4 1001.341h15.732l-10.362 13.493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.568 1016.428 18.457-12.218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m837.575 996.583h1.062a1.456 1.456 0 0 1 0 2.912h-.1l6.837 16.932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m831.1 1018.268h-5.383"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m792.458 980.5a3.555 3.555 0 1 1 3.555 3.553 3.555 3.555 0 0 1 -3.555-3.553z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.691 996.583 8.309 1.431v-2.44l-6.693-2.625-4.706-6.377a5.171 5.171 0 0 0 -6.308.535c-3.1 2.919-8.206 9.451-8.206 12.388 0 4.742 12.757 7.407 12.757 7.407l1.56 11.366h3.288l-.927-13.81-8.746-5.835 4.519-7.058z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m799.306 992.949-4.706-6.377a5.171 5.171 0 0 0 -6.308.535c-3.1 2.919-8.206 9.451-8.206 12.388 0 4.742 12.757 7.407 12.757 7.407l1.56 11.366h3.288l-.927-13.81-8.746-5.835 4.519-7.058 5.154 5.018 8.309 1.431v-2.44z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m824.357 980.5a3.555 3.555 0 1 1 3.555 3.553 3.555 3.555 0 0 1 -3.555-3.553z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m829 996.583 8.308 1.431v-2.44l-6.692-2.625-4.707-6.377a5.172 5.172 0 0 0 -6.308.535c-3.1 2.919-8.206 9.451-8.206 12.388 0 4.742 12.758 7.407 12.758 7.407l1.56 11.366h3.287l-.927-13.81-8.746-5.835 4.519-7.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m830.62 992.949-4.706-6.377a5.173 5.173 0 0 0 -6.309.535c-3.1 2.919-8.206 9.451-8.206 12.388 0 4.742 12.758 7.407 12.758 7.407l1.56 11.366h3.283l-.927-13.81-8.746-5.835 4.519-7.058 5.154 5.018 8.308 1.431v-2.44z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m806.262 996.583h1.061a1.456 1.456 0 0 1 0 2.912h-.1l6.838 16.932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m799.786 1018.268h-5.383"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m846.705 1016.427a1.332 1.332 0 1 1 -1.332-1.33 1.332 1.332 0 0 1 1.332 1.33z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTandem);
export default __webpack_public_path__ + "static/media/tandem.6141a2eb5cb38594f5c646f556425027.svg";
export { ForwardRef as ReactComponent };